import {useGetProductTemplateForeignKeys} from "api/api-hooks/product-templates-hooks";
import {MultiSelect} from "primereact/multiselect";
import React, {useEffect, useState} from "react";
import { T } from "services/lang/LanguageService";


export interface IForeignKey {
    value: IMultiForeignKeyValue;
    editable: boolean;
    foreignTemplateKey: string;
    changeHandler: any;
    foreignKeyWrap?: boolean;
}

export interface IMultiForeignKeyValue {
    objectIds: Array<string>;
    represantationString: string;
    template: string;
}

interface IOptions {
    objectId: string;
    represantationString: string;
    template: string;
}

export default function MultiForeignKey(props: IForeignKey) {
  const [options, setOptions] = useState<IOptions[]>([]);
  const [selectedItems, setSelectedItems] = useState<IOptions[]>([]);

  const { data, isError, error, isLoading } = useGetProductTemplateForeignKeys(
    props.foreignTemplateKey,
    { staleTime: 0, enabled: props.editable }
  );

  useEffect(() => {
    if (data) {
      const tempOptions = data.map((ob: IMultiForeignKeyValue) => {
        return { label: ob.represantationString, value: ob };
      });
      setOptions(tempOptions);
    }
  }, [data]);

  useEffect(() => {
    if (props.value) {
      const selectedItems = props.value.objectIds.map(objectId => {
        return {
          objectId,
          template: props.value.template,
          represantationString:
            props.value.represantationString.split("| ")[props.value.objectIds.indexOf(objectId)],
        };
      });
      setSelectedItems(selectedItems);
    }
  }, [props.value]);

  const handleChange = (value: IOptions[]) => {
    setSelectedItems(value);
    if (!value || value.length === 0) {
      props.changeHandler(null);
      return;
    }
    const transformedValue = {
      objectIds: value.map((item: IOptions) => item.objectId),
      template: value[0]?.template,
      represantationString: value.map((item: IOptions) => item.represantationString).join("| "),
    };

    props.changeHandler(transformedValue);
  };
  if (props.editable) {
    return (
      <>
        {isLoading && <>{T("word.loading")}</>}

        {isError && <>{error}</>}

        {!isLoading && !isError && (
          <MultiSelect
            style={{ width: "100%", textAlign: "left" }}
            value={selectedItems}
            options={options}
            onChange={e => handleChange(e.value)}
            placeholder={T("action.select-keys")}
            filter
            showClear
          />
        )}
      </>
    );
  }
  return (
    <>
      {props?.value?.represantationString ? (
        <div
          className="p-inputtext"
          style={{
            border: "0px transparent",
            backgroundColor: "transparent",
            whiteSpace: props.foreignKeyWrap ? "pre-wrap" : "nowrap",
          }}
          dangerouslySetInnerHTML={{
            __html: props.value.represantationString.replace(/\|/g, "<br/>"),
          }}
        />
      ) : (
        "-"
      )}
    </>
  );
}